import { Check } from "lucide-react";

export default function ProgressSteps({ current, total = 3, labels = [] }) {
  return (
    <div data-testid="progress-steps" className="w-full">
      <div className="flex items-center gap-2">
        {Array.from({ length: total }).map((_, i) => {
          const stepNum = i + 1;
          const isDone = stepNum < current;
          const isActive = stepNum === current;
          return (
            <div key={i} className="flex-1 flex items-center gap-2">
              <div
                data-testid={`step-indicator-${stepNum}`}
                className={[
                  "flex items-center justify-center h-8 w-8 rounded-full text-xs font-semibold shrink-0 transition-colors",
                  isDone
                    ? "bg-[#16A34A] text-white"
                    : isActive
                    ? "bg-[#334E68] text-white"
                    : "bg-gray-200 text-gray-500",
                ].join(" ")}
              >
                {isDone ? <Check className="w-4 h-4" /> : stepNum}
              </div>
              {i < total - 1 && (
                <div
                  className={[
                    "flex-1 h-1 rounded-full",
                    stepNum < current ? "bg-[#16A34A]" : "bg-gray-200",
                  ].join(" ")}
                />
              )}
            </div>
          );
        })}
      </div>
      {labels.length > 0 && (
        <p className="mt-3 text-xs uppercase tracking-wider text-gray-500 font-medium">
          Step {current} of {total} · {labels[current - 1]}
        </p>
      )}
    </div>
  );
}
